import colors from '@/config/colors';
import { StyleSheet } from 'react-native';

export const styles = StyleSheet.create({
  fullHeight: {
    flex: 1,
    flexDirection: 'column',
    backgroundColor: '#FFFFFF',
  },
  container: {
    flex: 1,
    flexDirection: 'column',
    backgroundColor: '#FFFFFF',
    paddingTop: 10,
  },
  textInstructions: {
    paddingTop: 30,
    fontWeight: '400',
    fontSize: 18,
    paddingBottom: 10,
    textAlign: 'center',
  },
  text: {
    fontWeight: '400',
    fontSize: 18,
    paddingBottom: 10,
    textAlign: 'center',
  },
  inputContainer: {
    flex: 1,
    flexDirection: 'row',
    alignSelf: 'center',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: 460,
    height: 150,
    paddingHorizontal: 10,
    paddingTop: '2%',
    paddingBottom: '3%',
  },
  inputBox: {
    paddingTop: 10,
    maxHeight: 70,
    minWidth: 320,
    backgroundColor: '#F8F8F8',
    borderBottomColor: '#555555',
    borderBottomWidth: 4,
  },
  inputText: {
    fontSize: 27,
    fontWeight: '400',
    textAlign: 'left',
    paddingVertical: 1,
    paddingHorizontal: 2,
    color: colors.black,
  },
  inputBorderError: {
    borderBottomWidth: 4,
    borderBottomColor: 'rgb(221, 44, 0)',
  },
  inputBorderAccepted: {
    borderBottomWidth: 4,
    borderBottomColor: '#51BF92',
  },
  digaCodeList: {
    fontSize: 18,
    paddingVertical: 10,
    textAlign: 'center',
  },
  email: {
    color: '#91C1DE',
  },
  emailPopUp: {
    color: '#51BF92',
    fontWeight: '700',
  },
  bold: {
    fontWeight: '700',
  },
  information: {
    fontWeight: '400',
    fontSize: 22,
    paddingVertical: 9,
    textAlign: 'center',
  },
  digaWrapper: {
    flexDirection: 'column',
    marginVertical: 10,
    paddingVertical: 10,
    borderTopWidth: 2,
    borderTopColor: '#F1F1F1',
  },
  listWrapper: {
    flexDirection: 'column',
    marginVertical: 10,
    paddingTop: '3%',
    borderTopWidth: 2,
    borderTopColor: '#F1F1F1',
  },
  errorWrapper: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    paddingVertical: '12%',
  },
  errorInternetHeader: {
    fontSize: 26,
    fontWeight: '700',
  },
  errorInternetSubtitle: {
    fontSize: 18,
    fontWeight: '500',
  },
  errorInternetLink: {
    fontSize: 24,
    fontWeight: '700',
    color: '#91C1DE',
  },
});
